import Decimal from 'decimal.js';
import { serviceBillingModel, serviceCostModel, serviceModel } from "../../models";
export let BillingGroupTypes = /*#__PURE__*/function (BillingGroupTypes) {
  BillingGroupTypes["Today"] = "today";
  BillingGroupTypes["OnEffectiveDate"] = "on the effective date";
  BillingGroupTypes["Once"] = "once";
  BillingGroupTypes["Weekly"] = "weekly";
  BillingGroupTypes["BiWeekly"] = "every two weeks";
  BillingGroupTypes["Monthly"] = "monthly";
  BillingGroupTypes["Quarterly"] = "quarterly";
  BillingGroupTypes["Yearly"] = "yearly";
  return BillingGroupTypes;
}({});
export function summarize() {
  let {
    selectedOptionalServices = [],
    effectiveDate = null,
    now = new Date(),
    billingFrequencyOnly = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    selectedOptionalServices: [],
    effectiveDate: null,
    now: new Date(),
    billingFrequencyOnly: false
  };
  return function doSummary(summary, service) {
    const cost = serviceModel.cost(service);
    const variablePrice = serviceCostModel.isVariablePrice(cost);
    const rangePrice = serviceCostModel.isRangePrice(cost);
    const name = serviceModel.name(service);
    const billedUpfront = serviceModel.isBilledUpfront(service);
    const billing = serviceModel.billingTrigger(service);
    const period = serviceBillingModel.period(billing);
    const recurring = serviceBillingModel.isRecurring(billing);
    const automatic = serviceBillingModel.isAutomatic(billing);
    const price = serviceModel.applyDiscount(service);
    const minPrice = serviceModel.minPriceFinal(service);
    const prorated = serviceModel.isProrated(service);
    const paused = serviceModel.isPaused(service);
    const skipsOnAcceptance = serviceModel.isSkipBillingOnAcceptance(service);
    const optional = serviceModel.isOptional(service.participation) && !selectedOptionalServices.includes(serviceModel.id(service));
    const unitName = serviceModel.unitName(service);
    const isFutureDate = effectiveDate != null && effectiveDate > now;
    if (optional) return summary;
    if (recurring) {
      if (automatic && billedUpfront && !paused && !skipsOnAcceptance) {
        if (isFutureDate) {
          addToSummary(BillingGroupTypes.OnEffectiveDate);
        } else {
          addToSummary(BillingGroupTypes.Today);
        }
      }
    } else {
      if (automatic && !billingFrequencyOnly) {
        if (isFutureDate) {
          addToSummary(BillingGroupTypes.OnEffectiveDate);
        } else {
          addToSummary(BillingGroupTypes.Today);
        }
      } else {
        addToSummary(BillingGroupTypes.Once);
      }
    }
    if (period != null) {
      const group = (() => {
        if (period === 'weekly') {
          return BillingGroupTypes.Weekly;
        } else if (period === 'biweekly') {
          return BillingGroupTypes.BiWeekly;
        } else if (period === 'monthly') {
          return BillingGroupTypes.Monthly;
        } else if (period === 'quarterly') {
          return BillingGroupTypes.Quarterly;
        } else {
          return BillingGroupTypes.Yearly;
        }
      })();
      addToSummary(group);
    }
    return summary;
    function addToSummary(groupType) {
      if (summary[groupType] == null) {
        summary[groupType] = new Map();
      }
      if (!summary[groupType].has(variablePrice || rangePrice)) {
        summary[groupType].set(variablePrice || rangePrice, {
          totalAmount: new Decimal(0),
          services: [],
          hasBilledUpfront: false
        });
      }
      const group = summary[groupType].get(variablePrice || rangePrice);
      group.totalAmount = group.totalAmount.plus(price);
      group.services = group.services.concat({
        name,
        price,
        minPrice,
        prorated,
        isRange: rangePrice,
        unit: unitName
      });
      group.hasBilledUpfront = group.hasBilledUpfront || billedUpfront || false;
      return summary;
    }
  };
}